export const GET_STUDENT_APPLIANCE_LIST_REQUEST = 'GET_STUDENT_APPLIANCE_LIST_REQUEST'
export const GET_STUDENT_APPLIANCE_LIST_FAIL = 'GET_STUDENT_APPLIANCE_LIST_FAIL'
export const GET_STUDENT_APPLIANCE_LIST_SUCCESS = 'GET_STUDENT_APPLIANCE_LIST_SUCCESS'

export const ATTACH_SERIAL_NO_REQUEST = 'ATTACH_SERIAL_NO_REQUEST'
export const ATTACH_SERIAL_NO_FAIL = 'ATTACH_SERIAL_NO_FAIL'
export const ATTACH_SERIAL_NO_SUCCESS = 'ATTACH_SERIAL_NO_SUCCESS'

export const DELETE_STUDENT_APPLIANCE_REQUEST = 'DELETE_STUDENT_APPLIANCE_REQUEST'
export const DELETE_STUDENT_APPLIANCE_FAIL = 'DELETE_STUDENT_APPLIANCE_FAIL'
export const DELETE_STUDENT_APPLIANCE_SUCCESS = 'DELETE_STUDENT_APPLIANCE_SUCCESS'

export const RESET_STUDENT_APPLIANCE = 'RESET_STUDENT_APPLIANCE'

export const STUDENT_APPLIANCE_LIST_SET_PAGINATION = 'STUDENT_APPLIANCE_LIST_SET_PAGINATION'
